<template>
    <div class="discount-cards">
        <div class="discount-buttons">
            <div>
                <button :disabled="isTempButtonClicked" class="d-button" @click="addTemporaryCustomer">Add customer</button>
            </div>
            <div>
                <button class="d-button blue" @click="toggleScanner(true)"><span class="qr"></span>Scan QR</button>
                <QRScanner v-if="showScanner" @toggle-scanner="toggleScanner" @show-customer-details="showCustomerDetails"></QRScanner>
                <div class="search-email-wrap">
                    <div v-if="showEmailLoading" class="email-loading-wrap">
                        <div class="email-wrap">
                            <span class="email-loading"> Searching Customer... </span>
                        </div>
                    </div>
                    <a href="javascript: void(0)" @click="toggleSearchBox" v-text="emailSearchText" class="search-email"></a>
                    <div v-if="isEmailSearchOpen" class="form-control">
                        <input type="email" placeholder="Customer Email" v-model="customerEmail" @keyup.enter="searchEmail" />
                        <button @click="searchEmail">Search</button>
                    </div>
                </div>
            </div>
        </div>
        
        <customerDetails v-if="buttonToggle" :isReturning="isReturning" @set-button-toggle="setButtonToggle"></customerDetails>
        <div v-if="buttonToggle && app_config == 'production'" class="d-flex justify-content-end">
            <button :disabled="popupOpen" @click="assignNFC" class="nfc-cta">Assign Wristband</button>
        </div>
        <div v-if="buttonToggle && (app_config == 'local' || app_config == 'staging')" class="d-flex justify-content-end">
            <button :disabled="popupOpen" @click="assignNFCDummy" class="nfc-cta">Assign Wristband</button>
        </div>
        <div v-if="toggleNFCAssign" class="nfc-overlay">
            <div class="nfc-wrap">
                <div class="nfc-container">
                    <h2 v-text="nfcTitle"></h2>
                    <p v-html="nfcDesc"></p>
                    <button class="nfc-cta" @click="refreshMe">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import customerDetails from "./DiscountCustomerDetails";
    import QRScanner from "./QRScannerComponent";
    import {mapActions, mapState} from 'vuex';
    import Swal from '../sweetAlert2/index';

    export default {
        props: ['app_config', 'customer_id'],
        components: {
            customerDetails,
            QRScanner
        },
        data() {
            return {
                isReturning: true,
                buttonToggle: false,
                showScanner: false,
                isTempButtonClicked: false,
                nfcTitle: "Scan NFC Tag",
                nfcDesc: "Tap NFC Tag into the device.",
                isScanning: true,
                nfcAssignSuccess: false,
                toggleNFCAssign: false,
                emailSearchText: "Search by customer email",
                isEmailSearchOpen: false, 
                customerEmail: "",
                customerId: null,
                showEmailLoading: false,
                macAddress: ""
            }
        },
        computed: {
            ...mapState([
                'discountCustomer', 
                'discountCustomerFound', 
                'popupOpen', 
                'nfcAssignSuccessful',
                'nfcTagAlreadyAssigned'
            ]),
        },
        methods: {
            ...mapActions([
                'fetchDiscountLogic', 
                'addTempCustomer', 
                'assignNFCToCustomer', 
                'searchCustomerByEmail',
                'searchCustomerById',
                'searchCustomerByQr',
                'checkIfCustomerHasNFC',
                'beep'
                ]),
            async addTemporaryCustomer() {
                this.isTempButtonClicked = true;
                await this.addTempCustomer();
                this.showCustomerDetails(false)
            },
            showCustomerDetails(value) {
                this.buttonToggle = true;
                this.isReturning = value;
            },
            hideCustomerDetails() {
                this.buttonToggle = false;
                this.isReturning = false;
                this.isTempButtonClicked = false;
            },
            setButtonToggle(value) {
                this.buttonToggle = value;
                this.isTempButtonClicked = value;
            },
            toggleScanner(value) {
                this.hideCustomerDetails();

                if(typeof FullyKiosk != "undefined") {
                    fully.scanQrCode("Scan Customer QR Code.", console.log('qr code running'), 0, 30, true, true, false);
                } else {
                    this.showScanner = value;
                }

                if(!value) {
                    this.setButtonToggle(value);
                }
                
            },
            toggleSearchBox() {

                this.isEmailSearchOpen = !this.isEmailSearchOpen;
                this.customerEmail = '';

                if(this.isEmailSearchOpen) {
                    this.emailSearchText = "Hide search box";
                } else {
                    this.emailSearchText = "Search by customer email";
                }
            },
            async assignNFC() {
                if(this.isReturning) {
                    await this.checkIfCustomerHasNFC(this.discountCustomer.hashed);

                    if(this.nfcTagAlreadyAssigned) {
                            new Swal({
                            title: 'Assigning new NFC tag for this customer',
                            text: "You won't be able to revert this!",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Proceed'
                            }).then((result) => {
                            if (result.isConfirmed) {
                                this.PerformNFCScan();
                            }
                        })
                    } else {
                        this.PerformNFCScan();
                    }
                } else {
                    this.PerformNFCScan();
                }
            },
            async PerformNFCScan() {
                this.toggleNFCAssign = true;

                try {
                    if(!this.nfcAssignSuccess && this.toggleNFCAssign) {

                        this.nfcTitle = "Scanning NFC...";

                        if(typeof FullyKiosk != "undefined") {
                            this.macAddress = fully.getMacAddress();
                            fully.nfcScanStart();
                        } else {
                            const ndef = new NDEFReader();
                            await ndef.scan();
                            
                            ndef.addEventListener("readingerror", () => {
                                this.nfcTitle = "Error!";
                            });

                            ndef.addEventListener("reading", async ({ serialNumber }) => {
                                this.beep();
                                await this.assignNFCToCustomer({
                                    serialNumber: serialNumber, 
                                    macAddress: this.macAddress
                                });

                                if(this.nfcAssignSuccessful) {
                                    this.nfcTitle = "DONE!";
                                    this.nfcDesc = "NFC successfully assigned to the Customer.";
                                    this.isScanning = false;
                                    this.nfcAssignSuccess = true;
                                }
                            });
                        }
                    }
                } catch (error) {
                    this.nfcTitle = "Error!";
                    this.nfcDesc = error + ". Please contact system administrator.";
                    this.isScanning = false;
                }
            },
            async kioskNFCScan({detail}) {
                try {
                    fully.nfcScanStop();
                    this.beep();
                    await this.assignNFCToCustomer({
                            serialNumber: detail.serialNumber, 
                            macAddress: this.macAddress
                        });

                    if(this.nfcAssignSuccessful) {
                        this.nfcTitle = "DONE!";
                        this.nfcDesc = "NFC successfully assigned to the Customer.";
                        this.isScanning = false;
                        this.nfcAssignSuccess = true;
                        fully.nfcScanStop();
                    }
                    
                } catch (error) {
                    this.nfcTitle = "Error!";
                    this.nfcDesc = error + ". Please contact system administrator.";
                    this.isScanning = false;
                }
            },
            async kioskQRScan({detail}) {
                try {
                    this.showEmailLoading = true;

                    await this.searchCustomerByQr(detail.code)

                    if(this.discountCustomerFound) {
                        this.showCustomerDetails(true);
                    } else {
                        this.hideCustomerDetails();
                    }

                    this.showEmailLoading = false;
                } catch (error) {
                    console.log(error);
                }
            },
            kioskQRCancel() {
                this.setButtonToggle(false);
            },
            async assignNFCDummy() {
                if(this.isReturning) {
                    await this.checkIfCustomerHasNFC(this.discountCustomer.hashed);

                    if(this.nfcTagAlreadyAssigned) {
                            new Swal({
                            title: 'Assigning new NFC tag for this customer',
                            text: "You won't be able to revert this!",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Proceed'
                            }).then((result) => {
                            if (result.isConfirmed) {
                                this.PerformDummyNFC();
                            }
                        })
                    } else {
                        this.PerformDummyNFC();
                    }
                } else {
                    this.PerformDummyNFC();
                }
            },
            async PerformDummyNFC() {
                this.toggleNFCAssign = true;
                const serialNumber = this.NFCFaker(20);
                console.log(serialNumber);
                await this.assignNFCToCustomer({
                        serialNumber: serialNumber, 
                        macAddress: this.macAddress
                    });
                
                if(this.nfcAssignSuccessful) {
                    this.nfcTitle = "DONE!";
                    this.nfcDesc = "Copy the NFC Code: <strong>" + serialNumber + "</strong>";
                    this.isScanning = false;
                    this.nfcAssignSuccess = true;
                }
            },
            refreshMe() {

                if(typeof FullyKiosk != "undefined") {
                    fully.nfcScanStop();
                }

                if(this.nfcAssignSuccess) {
                    window.location.href = "/ap/cr";
                } else {
                    this.toggleNFCAssign = false;
                }
            },
            NFCFaker(length) {
                let result           = '';
                const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%';
                const charactersLength = characters.length;
                for ( let i = 0; i < length; i++ ) {
                    result += characters.charAt(Math.floor(Math.random() * 
                    charactersLength));
                }
                return result;
            },
            async searchEmail() {
                if(!this.customerEmail) {
                    alert('Please enter customer email');
                    return;
                }
                this.showEmailLoading = true;
                await this.searchCustomerByEmail(this.customerEmail)

                if(this.discountCustomerFound) {
                    this.showCustomerDetails(true);
                } else {
                    this.hideCustomerDetails();
                }
                this.showEmailLoading = false;
            },
            async searchCustomerId() {
                if(this.customerId) {
                    this.showEmailLoading = true;
                    await this.searchCustomerById(this.customerId)

                    if(this.discountCustomerFound) {
                        this.showCustomerDetails(true);
                    } else {
                        this.hideCustomerDetails();
                    }
                    this.showEmailLoading = false;
                }
            }
        },
        async mounted() {
            window.addEventListener('nfc_serial_to_vue_admin', this.kioskNFCScan)
            window.addEventListener('qr_code_to_vue_admin', this.kioskQRScan)
            window.addEventListener('cancel_qr_code_to_vue_admin', this.kioskQRCancel)

            await this.fetchDiscountLogic();
            
            if(this.customer_id) {
                this.customerId = this.customer_id;
                await this.searchCustomerId();
            }
        },
        destroyed() {
            window.removeEventListener('nfc_serial_to_vue_admin', this.kioskNFCScan, false);
            window.removeEventListener('qr_code_to_vue_admin', this.kioskQRScan, false);
            window.addEventListener('cancel_qr_code_to_vue_admin', this.setButtonToggle(false), false)
        }
    }
</script>